import { render, staticRenderFns } from "./WidgetPieChart.vue?vue&type=template&id=54acc64c"
import script from "./WidgetPieChart.vue?vue&type=script&lang=js"
export * from "./WidgetPieChart.vue?vue&type=script&lang=js"
import style0 from "./WidgetPieChart.vue?vue&type=style&index=0&id=54acc64c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports